import { Box, Chip } from "@mui/material"
import { FieldUpdate } from "event-definitions"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { noChange, useRefresh } from "lib/@hooks/useRefresh"
import { getTaskReferenceCode } from "library/get-task-reference-code.mjs"

export function TaskReferenceCode() {
    // task is the row's bound task; schedule is inherited from the editor's outer context
    const { task, schedule } = useBoundContext()
    const refresh = useRefresh(noChange)
    // useBoundValue subscribes to updates of this row's target (the task), so the chip
    // regenerates live as the frequency is edited
    const [interval] = useBoundValue("frequency.interval")
    const [period] = useBoundValue("frequency.period")
    // The tag is edited on the schedule target (Details tab), a different Bound target,
    // so subscribe to its FieldUpdate directly
    FieldUpdate("clientReferenceTag").useEvent(refreshOnScheduleTagChange, [schedule])

    const code = getTaskReferenceCode({
        tag: schedule?.clientReferenceTag,
        // The frequency editor holds the interval as a string mid-edit; coerce so the
        // chip does not flicker off while typing
        frequency: { interval: toWholeNumber(interval), period },
    })
    if (!code || task?.isHeader) return null
    return (
        <Box sx={{ width: 1, display: "flex", justifyContent: "flex-end", pb: 0.5, pr: 1 }}>
            <Chip size="small" variant="outlined" label={code} data-cy="task-reference-code" />
        </Box>
    )

    function refreshOnScheduleTagChange(v, owner) {
        if (owner === schedule) refresh()
    }
}

function toWholeNumber(value) {
    const number = typeof value === "string" && value.trim() !== "" ? Number(value) : value
    return Number.isInteger(number) ? number : NaN
}
